module.exports = __webpack_public_path__ + "img/sadnMaskeran.4490fc73.jpg";